// Tenantra Inc. - Paywall Hook
// Handles 402 Payment Required errors and shows paywall modal
import { useState, useCallback } from 'react';

export function usePaywall() {
  const [paywallState, setPaywallState] = useState({
    isOpen: false,
    action: null,
    planRequired: null,
    message: null
  });

  const showPaywall = useCallback(({ action, planRequired, message }) => {
    setPaywallState({
      isOpen: true,
      action,
      planRequired,
      message
    });
  }, []);

  const hidePaywall = useCallback(() => {
    setPaywallState({
      isOpen: false,
      action: null,
      planRequired: null,
      message: null
    });
  }, []);

  const handlePaymentError = useCallback((error) => {
    // Check if it's a 402 Payment Required error
    if (error.response?.status === 402) {
      const detail = error.response.data?.detail;
      
      if (typeof detail === 'object' && detail.payment_required) {
        showPaywall({
          action: detail.action,
          planRequired: detail.plan_required,
          message: detail.message
        });
        return true; // Error was handled
      }
    }
    return false; // Error was not a paywall error
  }, [showPaywall]);

  return {
    paywallState,
    showPaywall,
    hidePaywall,
    handlePaymentError
  };
}
